import { useTranslate } from "@pankod/refine-core";

import {
  Edit,
  Drawer,
  DrawerProps,
  Form,
  FormProps,
  Input,
  // InputNumber,
  Radio,
  // Select,
  // SelectProps,
  // Space,
  ButtonProps,
  // Avatar,
  // Typography,
  // Upload,
  Grid, useSelect, Select,
  // getValueFromEvent,
  // useSelect,
} from "@pankod/refine-antd";
import {ICategory} from "../../interfaces";

// import { IOrganization } from "interfaces";

// const { Text } = Typography;

type EditCategoryProps = {
  drawerProps: DrawerProps;
  formProps: FormProps;
  saveButtonProps: ButtonProps;
};

export const EditCategory: React.FC<EditCategoryProps> = ({
  drawerProps,
  formProps,
  saveButtonProps,
}) => {
  const t = useTranslate();
  const breakpoint = Grid.useBreakpoint();
  const { selectProps: categorySelectProps } = useSelect<ICategory>({
    resource: "categories",
  });
  return (
    <Drawer
      {...drawerProps}
      width={breakpoint.sm ? "500px" : "100%"}
      bodyStyle={{ padding: 0 }}
      zIndex={1001}
      // closable={false}
    >
      <Edit saveButtonProps={saveButtonProps}>
        <Form
          {...formProps}
          layout="vertical"
        >
          <Form.Item
            label={t("categories.fields.title")}
            name="title"
            rules={[
              {
                required: true,
              },
            ]}
          >
            <Input />
          </Form.Item>
          <Form.Item
              label={t("categories.fields.parent_id")}
              // name={["organizationId", "id"]}
              name="parent_id"
          >
              <Select
                  //style={{ minWidth: 200 }}
                  //mode="multiple"
                  placeholder="Select parent category" {...categorySelectProps}
              />
          </Form.Item>
          <Form.Item label={t("categories.fields.isActive")} name="isActive">
            <Radio.Group>
              <Radio value={true}>{t("status.enable")}</Radio>
              <Radio value={false}>{t("status.disable")}</Radio>
            </Radio.Group>
          </Form.Item>
        </Form>
      </Edit>
    </Drawer>
  );
};
